export const formatData = [
	{
		id:'jpg',
		label:'JPG',
		description: 'Photos, lots of detail',
		contentType: 'image/jpeg'
	},
	{
		id:'png',
		label:'PNG',
		description: 'Graphics, shapes, logos',
		contentType: 'image/png'
	},
];